<template>
  <div>
    <AutomationWrapper></AutomationWrapper>
  </div>
</template>

<script>
import AutomationWrapper from "../../components/Common/AutomationWrapper.vue";
export default {
  components: {
    AutomationWrapper
  }
};
</script>

<style></style>
